import { motion } from "framer-motion"; // Import framer-motion
import { useInView } from "react-intersection-observer"; // Import useInView
import Button from "./Button"; // Import Button component

const slideInLeft = {
	hidden: {
		opacity: 0,
		x: -100,
		transition: { duration: 0.9, ease: "easeInOut" },
	},
	visible: {
		opacity: 1,
		x: 0,
		transition: { type: "spring", duration: 0.9, bounce: 0.2 },
	},
};

const slideInRight = {
	hidden: {
		opacity: 0,
		x: 100,
		transition: { duration: 0.9, ease: "easeInOut" },
	},
	visible: {
		opacity: 1,
		x: 0,
		transition: { type: "spring", duration: 0.9, bounce: 0.2 },
	},
};

function AboutSection() {
	const [ref, inView] = useInView({
		// triggerOnce: true, // Removed to allow re-trigger
		threshold: 0.4, // Trigger when 20% of the section is visible
	});

	return (
		<div
			ref={ref}
			className="grid grid-cols-1 md:grid-cols-2 justify-center items-center rounded-2xl gap-6 overflow-hidden"
		>
			<motion.div
				initial="hidden"
				animate={inView ? "visible" : "hidden"}
				variants={slideInRight}
				className="flex overflow-hidden md:hidden bg-steerOrange rounded-2xl"
			>
				<img
					src="/images/559972.webp"
					alt="Why Steer Smart"
					className="object-cover"
					width="800"
					height="533"
				/>
			</motion.div>

			<motion.div
				initial="hidden"
				animate={inView ? "visible" : "hidden"}
				variants={slideInLeft}
				className="flex flex-col space-y-12 font-generalSans bg-white/60 backdrop-blur-md p-6 rounded-2xl"
			>
				<div className="flex flex-col gap-4">
					<h2 className="font-semibold text-2xl text-steerBlack">
						We Are Canberra&apos;s #1 Choice For Driving Lessons
					</h2>
				</div>

				<p className="flex font-light text-steerLightBlackrounded-2xl lg:text-base text-sm">
					At Steer Smart driving school Canberra , we are committed to providing
					top-notch affordable driver training to help you become a safe and
					confident driver. Our team of experienced driving instructors in
					Canberra tailors each lesson to meet your individual needs, ensuring
					that you receive the best possible instruction at your own pace. We
					also provide valuable resources to help you prepare for key
					assessments such as the hazard perception test ACT, guiding you
					through the techniques and strategies required to pass with
					confidence. <br /> <br /> We understand the importance of practical
					experience, which is why we offer a road ready practice test to
					simulate real driving conditions and give you the confidence you need
					before taking your actual test. Our driving instructors in Canberra
					will work with you to refine your skills, ensuring you're
					well-prepared for both the driving test and everyday driving
					challenges. You can easily book driving classes at your convenience,
					and with our flexible scheduling, learning to drive has never been
					more accessible.
				</p>

				<Button
					buttonName="Book Now"
					buttonLink="/packages"
					buttonStyle="secondary"
				/>
			</motion.div>

			<motion.div
				initial="hidden"
				animate={inView ? "visible" : "hidden"}
				variants={slideInRight}
				className="hidden overflow-hidden md:flex bg-steerOrange rounded-2xl"
			>
				<img
					src="/images/559972.webp"
					alt="Why Steer Smart"
					className="object-cover"
					width="800"
					height="533"
				/>
			</motion.div>
		</div>
	);
}

export default AboutSection;
